<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-question-circle iconInterativoTitulo" main="Suporte Técnico"
            sub="Suporte Técnico da Hion Tecnologia" />
        <div class="stats">
            <Stat title="Fórum Técnico Hion" :value="stat.maquinas"
                icon="fab fa-steam-symbol" color="#2e2d2c" />
            <Stat title="Suporte Online" :value="stat.baterias"
                icon="fas fa-comment-dots" color="#ffd618" />
            <Stat title="Suporte por Telefone" :value="stat.usuarios"
                icon="fas fa-phone" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
    name: 'SuporteInterativa',
    components: { PageTitle, Stat },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>